<template>
  <div class="cmi-leicester">
    <div class="page-top">
      <div
        class="parallax"
        style="background:url(/dist/assets/images/ChurchImages/rupc_church_banner_003.jpg);"
      ></div>
      <div class="container">
        <h1>Audio online</h1>
        <ul>
          <li>
            <router-link to="/" :exact="true">Home</router-link>
          </li>
          <li>
            <router-link to="/shop-products">Teachings</router-link>
          </li>
        </ul>
      </div>
    </div>
    <section class="cmi-product-basket" v-if="showPayment == false">
      <transition
        name="basket-transition"
        enter-active-class="animated lightSpeedIn"
        leave-active-class="animated zoomOut"
      >
        <resource-view-basket :baseUrl="'Shop/Home/'"></resource-view-basket>
      </transition>
    </section>
    <section class="cmi-product-basket" v-if="showPayment == true">
      <transition
        name="card-transition"
        enter-active-class="animated lightSpeedIn"
        leave-active-class="animated zoomOut"
      >
        <div class="row">
          <div class="col-md-6 col-md-offset-3">
            <card :baseUrl="'Shop/Home/'"></card>
          </div>
        </div>
      </transition>
    </section>
    <section class="cmi-section">
      <resource-view-buy :baseUrl="'Shop/Home/'"></resource-view-buy>
    </section>
    <footer-cov></footer-cov>
  </div>
</template>
<script>
export default {
  components: {
    ResourceViewBuy: () => import("./ResourceViewBuy"),
    ResourceViewBasket: () => import("./ResourceViewBasket"),
    FooterCov: () => import("./FooterCoventry"),
    Card: () => import("./Card")
  },
  data() {
    return {};
  },
  computed: {
    showPayment: function() {
      return this.$store.state.showPaymentUI;
    }
  }
};
</script>
